'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFastCompare = require('react-fast-compare');

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _LACrownContainer = require('./LACrown/LACrownContainer');

var _LACrownContainer2 = _interopRequireDefault(_LACrownContainer);

var _WhiteLabelCrownContainer = require('./WhiteLabelCrown/WhiteLabelCrownContainer');

var _WhiteLabelCrownContainer2 = _interopRequireDefault(_WhiteLabelCrownContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Crown = function (_Component) {
    (0, _inherits3.default)(Crown, _Component);

    function Crown() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Crown);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Crown.__proto__ || (0, _getPrototypeOf2.default)(Crown)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = function (nextProps) {
            return !(0, _reactFastCompare2.default)(_this.props, nextProps);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Crown, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                location = _props.location,
                whiteLabel = _props.whiteLabel;


            return whiteLabel ? (0, _jsx3.default)(_WhiteLabelCrownContainer2.default, {}) : (0, _jsx3.default)(_LACrownContainer2.default, {
                location: location
            });
        }
    }]);
    return Crown;
}(_react.Component);

exports.default = Crown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Crown.js
// module id = 8tqB
// module chunks = 60